import React from "react";
import { ThemeProvider } from "styled-components";

const theme = {
  colors: {
    main: "#1DF36C",
    mainHover:"#17D55D",
    mainDark: "#1BE764",
    greenDark:"#006855",
    blueLight:"#AFCFCF",
    black: "#1D2B28",
    white: "#fff",
    blueDark: "#016069",
    linearBackground:"linear-gradient(180deg, rgba(239,234,224,1) 0%, rgba(255,255,255,1) 100%);"
  },
  fonts: ["Manrope", "sans-serif"],
  fontSizes: {
    small: "1em",
    medium: "2em",
    large: "3em"
  }
};

const Theme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);

export default Theme;